import { Avatar, Grid, Typography } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import PhoneIcon from "@material-ui/icons/Phone";
import cuideoTheme from "../../../../../../../../containers/themes/defaultTheme";
import EmailIcon from "@material-ui/icons/Email";

const StyledWrapper = styled.div``;

const StyledFullName = styled(Typography)`
  font-size: 0.9375rem;
  color: ${cuideoTheme.palette.primary.main};
  font-weight: 600;
`;

const StyledDetails = styled.div`
  color: ${cuideoTheme.palette.primary.main};
  font-size: 0.75rem;
  opacity: 0.75;

  .MuiSvgIcon-root {
    width: 1rem;
    height: 1rem;
  }
  .CMuiContactDetailCellDetail {
    font-size: 0.8125rem;
  }
`;

interface IContactDetailCellProps {
  First_Name?: string;
  Last_Name?: string;
  Phone?: string;
  Email?: string;
}

const ContactDetailCell = (props: IContactDetailCellProps) => {
  const { First_Name, Last_Name, Phone, Email } = props;

  return (
    <StyledWrapper>
      <Grid container spacing={4} wrap="nowrap">
        <Grid item>
          <Avatar />
        </Grid>
        <Grid item>
          <StyledFullName>
            {First_Name} {Last_Name}
          </StyledFullName>
          <StyledDetails>
            <Grid container spacing={4} alignItems="center">
              {Phone && (
                <Grid item>
                  <Grid container spacing={2} alignItems="center" wrap="nowrap">
                    <Grid item>
                      <PhoneIcon />
                    </Grid>
                    <Grid item>
                      <Typography className="CMuiContactDetailCellDetail">
                        {Phone}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {Email && (
                <Grid item>
                  <Grid container spacing={2} alignItems="center" wrap="nowrap">
                    <Grid item>
                      <EmailIcon />
                    </Grid>
                    <Grid item>
                      <Typography className="CMuiContactDetailCellDetail">
                        {Email}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </StyledDetails>
        </Grid>
      </Grid>
    </StyledWrapper>
  );
};

export default ContactDetailCell;
